export default class MemberGroup {
  name: string;

  isOwner: boolean = false;

  constructor(name: string) {
    this.name = name || '';
  }
}
